module.exports = __webpack_public_path__ + "static/kiss-3af7678b3e63aced1d73ae9073c1a4f9.gif";